/**
 * @generated SignedSource<<f53a70cd602b186fb3992ed10ea55417>>
 * @relayHash 5b6afbfce3854e9bcb1bde3de2a8c2a7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e052df92530525eaef9def99c51a000bfaed4288154845f27656bb5592202c43

import type { ConcreteRequest } from 'relay-runtime';
export type useChangeHistoryDataQuery$variables = {
  after?: string | null;
  contentId: string;
  first?: AGG$Long | null;
};
export type useChangeHistoryDataQuery$data = {
  readonly contentHistory: {
    readonly nodes: ReadonlyArray<{
      readonly by: {
        readonly accountId?: string | null;
        readonly displayName: string | null;
      };
      readonly friendlyWhen: string;
      readonly message: string;
      readonly number: number;
      readonly when: string;
    } | null> | null;
    readonly pageInfo: {
      readonly endCursor: string | null;
      readonly hasNextPage: boolean;
    } | null;
  } | null;
  readonly singleContent: {
    readonly space: {
      readonly key: string | null;
    } | null;
    readonly subType: string | null;
    readonly type: string | null;
    readonly version: {
      readonly by: {
        readonly accountId?: string | null;
        readonly displayName: string | null;
      } | null;
      readonly friendlyWhen: string | null;
      readonly message: string | null;
      readonly number: number | null;
      readonly when: string | null;
    } | null;
  } | null;
};
export type useChangeHistoryDataQuery = {
  response: useChangeHistoryDataQuery$data;
  variables: useChangeHistoryDataQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "contentId",
    "variableName": "contentId"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v4 = [
  {
    "kind": "ScalarField",
    "name": "accountId"
  }
],
v5 = {
  "kind": "InlineFragment",
  "selections": (v4/*: any*/),
  "type": "KnownUser"
},
v6 = {
  "kind": "InlineFragment",
  "selections": (v4/*: any*/),
  "type": "UnknownUser"
},
v7 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v8 = {
  "kind": "ScalarField",
  "name": "friendlyWhen"
},
v9 = {
  "kind": "ScalarField",
  "name": "when"
},
v10 = {
  "kind": "ScalarField",
  "name": "message"
},
v11 = {
  "kind": "ScalarField",
  "name": "number"
},
v12 = [
  {
    "kind": "LinkedField",
    "name": "by",
    "plural": false,
    "selections": [
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ]
  },
  (v8/*: any*/),
  (v9/*: any*/),
  (v10/*: any*/),
  (v11/*: any*/)
],
v13 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    },
    {
      "kind": "ScalarField",
      "name": "endCursor"
    }
  ]
},
v14 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "contentId"
  },
  {
    "kind": "Literal",
    "name": "status",
    "value": [
      "current",
      "draft",
      "archived"
    ]
  }
],
v15 = {
  "kind": "ScalarField",
  "name": "type"
},
v16 = {
  "kind": "ScalarField",
  "name": "subType"
},
v17 = {
  "kind": "ScalarField",
  "name": "key"
},
v18 = [
  {
    "kind": "LinkedField",
    "name": "by",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "__typename"
      },
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ]
  },
  (v8/*: any*/),
  (v9/*: any*/),
  (v10/*: any*/),
  (v11/*: any*/)
],
v19 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useChangeHistoryDataQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "PaginatedContentHistoryList",
        "kind": "LinkedField",
        "name": "contentHistory",
        "plural": false,
        "selections": [
          {
            "concreteType": "ContentHistory",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": (v12/*: any*/)
          },
          (v13/*: any*/)
        ]
      },
      {
        "args": (v14/*: any*/),
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "singleContent",
        "plural": false,
        "selections": [
          (v15/*: any*/),
          (v16/*: any*/),
          {
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
              (v17/*: any*/)
            ]
          },
          {
            "concreteType": "Version",
            "kind": "LinkedField",
            "name": "version",
            "plural": false,
            "selections": (v12/*: any*/)
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "useChangeHistoryDataQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "PaginatedContentHistoryList",
        "kind": "LinkedField",
        "name": "contentHistory",
        "plural": false,
        "selections": [
          {
            "concreteType": "ContentHistory",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": (v18/*: any*/)
          },
          (v13/*: any*/)
        ]
      },
      {
        "args": (v14/*: any*/),
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "singleContent",
        "plural": false,
        "selections": [
          (v15/*: any*/),
          (v16/*: any*/),
          {
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
              (v17/*: any*/),
              (v19/*: any*/)
            ]
          },
          {
            "concreteType": "Version",
            "kind": "LinkedField",
            "name": "version",
            "plural": false,
            "selections": (v18/*: any*/)
          },
          (v19/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "5b6afbfce3854e9bcb1bde3de2a8c2a7",
    "id": "e052df92530525eaef9def99c51a000bfaed4288154845f27656bb5592202c43",
    "metadata": {},
    "name": "useChangeHistoryDataQuery",
    "operationKind": "query",
    "text": "query useChangeHistoryDataQuery($contentId:ID!,$after:String,$first:Long){contentHistory(contentId:$contentId,after:$after,first:$first){nodes{by{__typename,...on KnownUser{accountId},...on UnknownUser{accountId},displayName},friendlyWhen,when,message,number},pageInfo{hasNextPage,endCursor}},singleContent(id:$contentId,status:[\"current\",\"draft\",\"archived\"]){type,subType,space{key,id},version{by{__typename,...on KnownUser{accountId},...on UnknownUser{accountId},displayName},friendlyWhen,when,message,number},id}}"
  }
};
})();

(node as any).hash = "5c74bea9bed287cb9acb1aedf532afd9";

export default node;
